import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { AssetsDto } from './assets-classification.dto';



export class AssetsResponse extends GlobalResponseObject {
    data?: AssetsDto;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: AssetsDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
